/**
 * 학생 home "오늘의 서술형 문제" 카드.
 * `GET /app/essay-learning/chapters/preview`
 *
 * 미완료 챕터 1건을 반환한다. 0건이면 result 키 부재 → data === undefined.
 * 비로그인(accessToken 없음)이면 요청하지 않는다(조건부 fetch).
 */
import api from "pages/api/axiosInstance";
import useSWR from "swr";
import { EssayPreviewResponse } from "./types";

interface BaseResponse<T> {
  isSuccess: boolean;
  code: number;
  message: string;
  result?: T;
}

export const useGetEssayPreview = () => {
  // 게스트(비로그인)면 호출하지 않는다. accessToken 없이 authed endpoint 를 부르면
  // 401 → 토큰 갱신 흐름이 헛돈다(랜딩에서 무의미한 401). SWR key 가 null 이면 미요청.
  // typeof window 가드: static export 빌드 prerender 시에는 sessionStorage 가 없다.
  const hasSession =
    typeof window !== "undefined" && !!sessionStorage.getItem("accessToken");

  return useSWR<EssayPreviewResponse | undefined>(
    hasSession ? ["/app/essay-learning/chapters/preview"] : null,
    async ([url]: [string]) => {
      const res = await api.get<BaseResponse<EssayPreviewResponse>>(url);
      return res.data.result;
    }
  );
};

export default useGetEssayPreview;
